import type { SVGProps } from 'react';

const SvgLightning2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.34723 8.37123L10.9872 1.09379C11.3637 0.858118 11.7226 1.09379 11.4928 1.49809L8.73532 6.79895H13.6528C13.6528 6.79895 14.434 6.79895 13.6528 7.42786L5.15065 14.7502C4.5532 15.2443 4.13958 14.9748 4.5532 14.2111L7.21873 9.04506H2.34723C2.34723 9.04506 1.56596 9.04506 2.34723 8.37123Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgLightning2;
